var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'app-oce-container': _vm.fromOce == 1},attrs:{"id":"app"}},[_c('router-view'),(_vm.enableAI && !['login'].includes(_vm.$route.name))?_c('AIChatBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }